import React from 'react';
import { match } from 'react-router';
import { Query } from '@apollo/client/react/components';

import { RouteWithSearchRenderProps as RouteWithSearchProps } from 'lib/react-router/route-with-search';
import LoadingProgress from 'lib/react-router/loading-progress';

import ErrorPage from 'four-nets/errors/error-page';
import Unauthorized from 'four-nets/errors/401/unauthorized';
import NotFound from 'four-nets/errors/404/not-found';
import { ViewerConsumer } from 'four-nets/user/viewer/viewer';

import CreateEditArticle from './create-edit-article';
import query, { ArticleBySlugQuery, ArticleBySlugQueryVariables } from './create-edit-article.graphql';

interface Params {
    slug: string;
    username: string;
}

export interface Props {
    match: match<Params>;
}

export interface Props extends RouteWithSearchProps<Params, {}> {}

class EditLoader extends React.PureComponent<Props> {
    render() {
        const { username, slug } = this.props.match.params;

        return (
            <ViewerConsumer>
                {({ viewer }) => {
                    if (!viewer) {
                        return <Unauthorized />;
                    }

                    return viewer.username !== username ? (
                        <NotFound />
                    ) : (
                        <Query<ArticleBySlugQuery, ArticleBySlugQueryVariables>
                            query={query}
                            variables={{ slug, username }}
                        >
                            {({ error, data, loading, refetch }) =>
                                loading ? null : (
                                    <LoadingProgress loading={loading}>
                                        <ErrorPage error={error}>
                                            {data &&
                                            data.feed &&
                                            data.feed.edges &&
                                            data.feed.edges[0] &&
                                            data.feed.edges[0]!.node ? (
                                                <CreateEditArticle article={data.feed.edges[0]!.node} />
                                            ) : (
                                                <NotFound />
                                            )}
                                        </ErrorPage>
                                    </LoadingProgress>
                                )
                            }
                        </Query>
                    );
                }}
            </ViewerConsumer>
        );
    }
}

export default EditLoader;
